/* MENU */
const burgerMenu = document.getElementById('menu-burger');
const burgerMenuButton = document.getElementById('menu-burger--button')
const burgerTop = document.getElementById('menu-burger--top');
const burgerMiddle = document.getElementById('menu-burger--middle');
const burgerBottom = document.getElementById('menu-burger--bottom');
const nav = document.getElementById('nav')
var menuOpen = false

function toggleMenu() {
    burgerTop.classList.toggle('burger-top-open');
    burgerMiddle.classList.toggle('burger-middle-open');
    burgerBottom.classList.toggle('burger-bottom-open');
    burgerMenuButton.classList.toggle('burger-button-open');
    burgerMenu.classList.toggle('menu-burger--expanded');
    nav.classList.toggle('nav-open');
    menuOpen = !menuOpen;
}

//close Nav on Click
const navLinks = document.querySelectorAll('[data-main-nav-link ]')
navLinks.forEach(link => {
    link.addEventListener('click', () => {
        toggleMenu()
    })
})


document.addEventListener("DOMContentLoaded", function () {
    adjustHobbiesCards()
    window.addEventListener('click', (e) => {
        if (menuOpen && e.target !== burgerMenu && !burgerMenu.contains(e.target)) {
            burgerTop.classList.remove('burger-top-open');
            burgerMiddle.classList.remove('burger-middle-open');
            burgerBottom.classList.remove('burger-bottom-open');
            burgerMenuButton.classList.remove('burger-button-open');
            burgerMenu.classList.remove('menu-burger--expanded');
            nav.classList.remove('nav-open');
            menuOpen = !menuOpen;
        }
    })
})




/* CAROUSELS */

const carouselButtons = document.querySelectorAll('[data-carousel-button]')

carouselButtons.forEach(button => {
    button.addEventListener('click', () => {
        const offset = button.getAttribute("data-carousel-button") === "next" ? 1 : -1
        const slides = button.closest('[data-carousel]').querySelector('[data-slides]')
        const activeSlide = slides.querySelector('[data-active]')
        const dots = button.closest('[data-carousel]').querySelector('[data-carousel-dots]')
        const activeDot = dots.querySelector('[data-active]')

        let newIndex = [...slides.children].indexOf(activeSlide) + offset
        if (newIndex < 0) newIndex = slides.children.length - 1
        if (newIndex >= slides.children.length) newIndex = 0

        slides.children[newIndex].dataset.active = true
        delete activeSlide.dataset.active
        dots.children[newIndex].dataset.active = true
        delete activeDot.dataset.active
    })
})


//Vollbild schliessen, wenn exitbutton, oder ausserhalb des 
const fullScreenExitButton = document.querySelector('[data-full-screen-exit-button]')

fullScreenExitButton.addEventListener('click', () => {
    disableFullScreen()
})


const fullScreenImageContainer = document.querySelector('[data-full-screen-image-container]')


fullScreenImageContainer.addEventListener('click', (e) => {
    if (e.target === fullScreenImageContainer) {
        disableFullScreen()
    }
})

var fullScreenImage = document.querySelector('[data-full-screen-image]')
const fullScreenImageDescriptionContainer = document.querySelector('[data-full-screen-description]')


//vollbild anzeigen
const slides = document.querySelectorAll("[data-slides]")
slides.forEach(slide => {
    slide.addEventListener('click', () => {
        const activeSlide = slide.querySelector('[data-active]')
        fullScreenImage.src = activeSlide.children[0].src;
        fullScreenImageContainer.style.display = "flex";
        fullScreenImageDescriptionContainer.innerHTML = activeSlide.children[0].getAttribute("data-description")
        const indexOfCurrentImage = Array.prototype.slice.call(activeSlide.parentElement.children).indexOf(activeSlide)
        const numberOfImages = activeSlide.closest('[data-slides]').childElementCount
        const dotContainer = document.querySelector('[data-full-screen-image-dots]')
        /* console.log(dotContainer); */
        for (var i = 0; i < numberOfImages; i++) {
            const dot = document.createElement('div')
            dot.className = 'full-screen-image__dots__dot'
            dot.addEventListener('click', () => {
                changeImagefromFullScreenDot(dot);
            })
            if (i === indexOfCurrentImage) {
                dot.dataset.active = true
            }
            dotContainer.appendChild(dot)
        }


    })
})

const fullScreenCarouselButton = document.querySelectorAll('[data-full-screen-button]')

fullScreenCarouselButton.forEach(button => {
    button.addEventListener('click', () => {
        const offset = button.getAttribute("data-full-screen-button") === "next" ? 1 : -1
        changeFullScreenImage(offset)
    })
})

document.addEventListener('keydown', (e) => {
    if (fullScreenImageContainer.style.display === "flex") {
        if (e.key === 'ArrowLeft') {
            changeFullScreenImage(-1)
        }
        else if (e.key === 'ArrowRight') {
            changeFullScreenImage(1)
        }
        else if (e.key === 'Escape') {
            disableFullScreen()
        }
    }
})

function changeFullScreenImage(offset) {
    const fullScreenImage = document.querySelector('[data-full-screen-image]')
    const currentImageURL = fullScreenImage.src.split('/')
    const currentImageSrc = currentImageURL[currentImageURL.length - 1]
    const currentUl = document.querySelector("img[src='/" + currentImageSrc + "']").closest('[data-carousel]').querySelector('[data-slides]')
    /*     console.log(currentUl) */

    const slides = currentUl.closest('[data-carousel]').querySelector('[data-slides]')
    const activeSlide = slides.querySelector('[data-active]')
    /*     console.log(activeSlide); */
    const dots = currentUl.closest('[data-carousel]').querySelector('[data-carousel-dots]')
    const activeDot = dots.querySelector('[data-active]')
    /*     console.log(activeDot); */


    const fullScreenDots = document.querySelector('[data-full-screen-image-dots]')
    const activeFullScreenDot = fullScreenDots.querySelector('[data-active]')


    let newIndex = [...slides.children].indexOf(activeSlide) + offset
    if (newIndex < 0) newIndex = slides.children.length - 1
    if (newIndex >= slides.children.length) newIndex = 0
    //if (newIndex === 0) newIndex = [...slides.children].indexOf(activeSlide)

    slides.children[newIndex].dataset.active = true
    delete activeSlide.dataset.active
    fullScreenImage.src = slides.children[newIndex].children[0].src;
    fullScreenImageDescriptionContainer.innerHTML = slides.children[newIndex].children[0].getAttribute("data-description")

    fullScreenDots.children[newIndex].dataset.active = true
    delete activeFullScreenDot.dataset.active

    dots.children[newIndex].dataset.active = true
    delete activeDot.dataset.active
}

// dots for carousel
const carousels = document.querySelectorAll('[data-carousel]')
carousels.forEach((carousel) => {
    const dotContainer = carousel.querySelector('[data-carousel-dots]')
    const numberOfImages = carousel.querySelector('[data-slides]').childElementCount

    for (var i = 0; i < numberOfImages; i++) {
        const dot = document.createElement('div')
        dot.className = 'carousel__dots__dot'
        dot.addEventListener('click', () => {
            changeImagefromDot(dot);
        })
        if (i === 0) {
            dot.dataset.active = true
        }
        dotContainer.appendChild(dot)
    }

})

function changeImagefromDot(dot) {
    const slides = dot.closest('[data-carousel]').querySelector('[data-slides]');
    const activeSlide = slides.querySelector('[data-active]');
    const dots = dot.closest('[data-carousel-dots]');
    const activeDot = dots.querySelector('[data-active]');
    newIndex = Array.prototype.slice.call(dot.parentElement.children).indexOf(dot);
    /* console.log(`activeDot ${activeDot}`)
    console.log(`new: ${newIndex}`) */

    slides.children[newIndex].dataset.active = true;
    delete activeSlide.dataset.active;
    dot.dataset.active = true;
    delete activeDot.dataset.active;
}

function changeImagefromFullScreenDot(dot) {
    const dots = document.querySelector('[data-full-screen-image-dots]')
    const activeDot = dots.querySelector('[data-active]')
    oldIndex = Array.prototype.slice.call(activeDot.parentElement.children).indexOf(activeDot);
    newIndex = Array.prototype.slice.call(dot.parentElement.children).indexOf(dot);

    changeFullScreenImage(newIndex - oldIndex)
}

function disableFullScreen() {
    fullScreenImageContainer.style.display = "none";
    fullScreenImageContainer.querySelector('[data-full-screen-image-dots]').innerHTML = ''
}



/* HERO */
const TLHERO = gsap.timeline({
    y: -100,
    scrollTrigger: {
        trigger: "[data-hero]",
        start: "top top",
        end: "bottom top",
        scrub: true
    }
});

gsap.utils.toArray("[data-hero]").forEach(layer => {
    const movement = -(document.querySelector("[data-hero]").offsetHeight * .6)
    TLHERO.to(layer, { y: movement, ease: "none" }, 0)
});
/* OBSERVERS */

//timeline animation

//section title animation
/* const sectionTitleObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        const intersecting = entry.isIntersecting
        if (intersecting) {
            entry.target.classList.add('move-in-left')
        }
    })
}, { threshold: .7 });

const sectionTitles = document.querySelectorAll('[data-section-title]');
sectionTitles.forEach(title => {
    sectionTitleObserver.observe(title)
}) */


/* ABOUT ANIMATION */

let root = document.documentElement;

var path = document.querySelector("[data-hobbies-svg-path]");
var pathLenght = path.getTotalLength();

//set svg-length
root.style.setProperty('--hobbies-svg-length', Math.ceil(pathLenght));

/* console.log(pathLenght); */

const svgBG1 = document.querySelector('[data-hobbies-svg-bg-1]')
const svgBG2 = document.querySelector('[data-hobbies-svg-bg-2]')
const svgBG3 = document.querySelector('[data-hobbies-svg-bg-3]')
const svgBG4 = document.querySelector('[data-hobbies-svg-bg-4]')
const svgBG5 = document.querySelector('[data-hobbies-svg-bg-5]')

const hobbiesCards = document.querySelectorAll('[data-hobbies-card]')
var percentageOfImage = 0;

const svgImg = document.querySelectorAll('[data-hobbies-svg]')

window.addEventListener("scroll", () => {
    const viewportHeight = window.innerHeight;
    const hobbiesSvgContainerHeight = document.querySelector("[data-hobbies-container]").clientHeight;

    const relevantHeight = hobbiesSvgContainerHeight - viewportHeight;
    const positionOfViewport = document.querySelector("[data-hobbies-container]").getBoundingClientRect().top * -1;
    percentageOfImage = (1 / relevantHeight) * positionOfViewport;
    const strokeDashoffset = pathLenght - (percentageOfImage * pathLenght);


    if (percentageOfImage > 0) {
        root.style.setProperty("--hobbies-svg-stroke-dashoffset", strokeDashoffset);
        /* Backgrounds */
        /* 1 */
        if (percentageOfImage < 0.05 || percentageOfImage > 0.16) {
            gsap.to(svgBG1, { x: -450, y: 0, scale: 1 })
        }
        else {
            gsap.to(svgBG1, { x: 0, y: 0, scale: 1 })

        }
        /* 2 */
        if (percentageOfImage < 0.23 || percentageOfImage > 0.36) {
            gsap.to(svgBG2, { x: -450, y: 0, scale: 1 })
        }
        else {
            gsap.to(svgBG2, { x: 0, y: 0, scale: 1 })

        }
        /* 3 */
        if (percentageOfImage < 0.42 || percentageOfImage > 0.52) {
            gsap.to(svgBG3, { x: -450, y: 0, scale: 1 })
        }
        else {
            gsap.to(svgBG3, { x: 0, y: 0, scale: 1 })

        }
        /* 4 */
        if (percentageOfImage < 0.6 || percentageOfImage > 0.76) {
            gsap.to(svgBG4, { x: -450, y: 0, scale: 1 })
        }
        else {
            gsap.to(svgBG4, { x: 0, y: 0, scale: 1 })

        }
        /* 5 */
        if (percentageOfImage < 0.81 || percentageOfImage > 1) {
            gsap.to(svgBG5, { x: -450, y: 0, scale: 1 })
        }
        else {
            gsap.to(svgBG5, { x: 0, y: 0, scale: 1 })

        }

        /* Change Image*/
        if (percentageOfImage > 0.0 && percentageOfImage < 0.175) {

            gsap.to(svgImg, {
                duration: .2,
                attr: { viewBox: "0 0 500 1080" },
                ease: "none"
            });
        }
        else if (percentageOfImage > 0.175 && percentageOfImage < 0.36) {
            gsap.to(svgImg, {
                duration: .2,
                attr: { viewBox: "0 1120 500 1080" },
                ease: "none"
            });
        }
        else if (percentageOfImage > 0.36 && percentageOfImage < 0.54) {
            gsap.to(svgImg, {
                duration: .2,
                attr: { viewBox: "0 2160 500 1080" },
                ease: "none"
            });
        }
        else if (percentageOfImage > 0.54 && percentageOfImage < 0.76) {
            gsap.to(svgImg, {
                duration: .2,
                attr: { viewBox: "0 3240 500 1080" },
                ease: "none"
            });
        }
        else if (percentageOfImage > 0.76 && percentageOfImage < 1.00) {
            gsap.to(svgImg, {
                duration: .2,
                attr: { viewBox: "0 4320 500 1080" },
                ease: "none"
            });
        }
        else if (percentageOfImage > 1.00) {
            gsap.to(svgImg, {
                duration: .2,
                attr: { viewBox: "0 5400 500 1080" },
                ease: "none"
            });
        }

        /* Change text */
        /* 1 */
        if (percentageOfImage <= 0.01 || percentageOfImage > 0.17) {
            gsap.to(hobbiesCards[0], { x: '100vw', scale: 1 })
        }
        else {
            gsap.to(hobbiesCards[0], { x: 0, scale: 1 })
        }
        /* 2 */
        if (percentageOfImage < 0.19 || percentageOfImage > 0.36) {
            gsap.to(hobbiesCards[1], { x: '100vw', scale: 1 })
        }
        else {
            gsap.to(hobbiesCards[1], { x: 0, scale: 1 })
        }
        /* 3 */
        if (percentageOfImage < 0.38 || percentageOfImage > 0.53) {
            gsap.to(hobbiesCards[2], { x: '100vw', scale: 1 })
        }
        else {
            gsap.to(hobbiesCards[2], { x: 0, scale: 1 })
        }
        /* 4 */
        if (percentageOfImage < 0.55 || percentageOfImage > 0.75) {
            gsap.to(hobbiesCards[3], { x: '100vw', scale: 1 })
        }
        else {
            gsap.to(hobbiesCards[3], { x: 0, scale: 1 })
        }
        /* 5 */
        if (percentageOfImage < 0.77 || percentageOfImage > 1.0) {
            gsap.to(hobbiesCards[4], { x: '100vw', scale: 1 })
        }
        else {
            gsap.to(hobbiesCards[4], { x: 0, scale: 1 })
        }


    }
    else {
        root.style.setProperty("--hobbies-svg-stroke-dashoffset", pathLenght);

        hobbiesCards.forEach((hobbyContainer) => {
            gsap.to(hobbyContainer, { x: '100vw', scale: 1 })
        })
    }

    /* console.log(percentageOfImage); */
});


/* Hobbies scroll to next/prev */

const getOffset = (el) => {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    };
}

function customScrollTo(querySelector, factor, duration) {
    var e = document.documentElement;
    if (e.scrollTop === 0) {
        var t = e.scrollTop;
        ++e.scrollTop;
        e = t + 1 === e.scrollTop-- ? e : document.body;
    }
    //scrollToC(e, e.scrollTop, factor, duration);
    if (duration <= 0) return;
    from = window.pageYOffset;
    const toElement = document.querySelector(querySelector).getBoundingClientRect()
    var toElementDistanceToTop = window.pageYOffset + toElement.top
    var toTarget = (toElement.height - window.innerHeight) * factor
    var to = toElementDistanceToTop + toTarget; + scrollToX(e, from, to, 0, 1 / duration, 20, linear);
}

function scrollToX(element, xFrom, xTo, t01, speed, step, motion) {
    if (t01 < 0 || t01 > 1 || speed <= 0) {
        element.scrollTop = xTo;
        return;
    }
    element.scrollTop = xFrom - (xFrom - xTo) * motion(t01);
    t01 += speed * step;
    setTimeout(function () {
        //console.log(t01);
        scrollToX(element, xFrom, xTo, t01, speed, step, motion);
    }, step);
}

function easeInOutCubic(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}
function linear(x) {
    return x
}


/* 
document.querySelector('[data-section-devider-about]').addEventListener('click', () => {
    window.scrollBy(0, `${window.innerHeight * 4.5}`)
}) */

gsap.to('[data-section-devider-about]', {
    autoAlpha: 0,
    scrollTrigger: {
        trigger: '[data-section-devider-about]',
        //markers: true,
        start: '70% 100%',
        end: '100% 80%',
        scrub: .000001,
    }
})


window.addEventListener('resize', () => {
    adjustHobbiesCards()
});

function adjustHobbiesCards() {
    var dataHobbiesSvgWidth = document.querySelector('[data-hobbies-svg]').clientWidth;
    hobbiesCards.forEach((card) => {
        card.style.left = dataHobbiesSvgWidth * 1.15 + 'px'
    });
}
/* console.log(document.querySelector('[data-hobbies-svg]').clientWidth);
 */


/* section Titles */
gsap.utils.toArray("[data-section-title]").forEach((title) => {
    gsap.fromTo(title, {
        autoAlpha: 0,
    }, {
        autoAlpha: 1,
        x: 0,
        ease: "back(1)",
        scrollTrigger: {
            trigger: title,
            scrub: 1,
            //markers: true,
            start: '0% 90%',
            end: '80% 70%'
        }
    })
})


/* section Experience */
gsap.utils.toArray("[data-timeline-item]").forEach((item) => {
    gsap.to(item, {
        y: 0,
        //duration: 1,
        ease: "none",
        scrollTrigger: {
            trigger: item,
            scrub: 1,
            //markers: true,
            //start: '100% 100%',
            //end: '0% 0%'
        }
    })
})

/* Contact */


const TLCONTACT =
    gsap.fromTo("[data-contact-link]", {
        y: 100,
        autoAlpha: 0
    }, {
        y: 0,
        autoAlpha: 1,
        duration: 1,
        ease: "power4",
        stagger: .2,
        scrollTrigger: {
            trigger: "[data-contact-link]",
            start: 'auto 65%',
            //markers: true
        }
    })

/* SIGNATURE */
gsap.fromTo('[data-signature-path]', {
    strokeDashoffset: -933
}, {
    strokeDashoffset: 0,
    duration: 2,
    delay: 1.5,
    ease: "none",
    scrollTrigger: {
        trigger: "[data-signature-path]",
        //markers: true,
        start: 'auto 100%',
        end: 'auto 0%',

    }
}
)

/* projects  */
gsap.utils.toArray("[data-projekt-animation]").forEach((item) => {
    gsap.fromTo(item, {
        y: 100,
        autoAlpha: 0
    }, {
        y: 0,
        autoAlpha: 1,
        duration: .5,
        ease: "none",
        stagger: .2,
        scrollTrigger: {
            trigger: item,
            start: '0% 60%',
            end: '20% 100%',
            scrub: 1,
            //markers: true,
        }
    })
})

/* HERO IN */

function removeLoader() {
    const TLHEROIN = gsap.timeline({ duration: 1 })
    TLHEROIN.to('[data-loader]', {
        autoAlpha: 0,
        opacity: 0,
        x: '100vw',
        display: 'none',
        ease: "none"
    })
    TLHEROIN.from('[data-hero-flag]', {
        autoAlpha: 0,
        y: '-100px',
        ease: "power1",
        duration: 1
    }, 1.25)
    TLHEROIN.from('[data-hero-title]', {
        autoAlpha: 0,
        y: '100px',
        ease: "power1",
        duration: 1
    }, '-=.75')
    TLHEROIN.from('[data-hero-text]', {
        autoAlpha: 0,
        y: '100px',
        ease: "power1",
        duration: 1
    }, '-=.75')

}


gsap.to('[data-hero-section-devider]', {
    scale: 1.5,
    duration: 1,
    repeat: -1,
    ease: "none",
})


//
function sendContactMail() {
    var body = "Hoi Renzo%0D%0A%0D%0AGerne lernen wir dich besser kennen. Wann hättest du Zeit?%0D%0A%0D%0ADein baldiger Arbeitgeber";
    window.location.href = "mailto:renzosmania@hotmail.com?subject=Wir möchten dich gerne kennenlernen!&body=" + body;
}